

















import { Prop, Component, Vue, Inject } from "vue-property-decorator";

@Component
export default class AbcProgressBar extends Vue {
    @Prop({ default: 0 }) status!: number;
    @Prop({ default: "medium" }) size!: "small" | "medium" | "large";

    private get normPercentage() {
        if (this.status > 100) {
            return 100;
        } else if (this.status < 0) {
            return 0;
        }
        return Math.round(this.status);
    }

    private get sizeClass() {
        if (this.size === "small") {
            return "h-2";
        } else if (this.size === "medium") {
            return "h-4";
        }
        return "h-6";
    }
}
